import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  productItem: {
    display: 'flex',
  },
  productImage: {
    width: '72px',
    height: '72px',
    'object-fit': 'cover',
  },
  cart: {
    width: '200px',
  },
  productDescription: {
    marginLeft: '8px',
    '& > h3': {
      display: '-webkit-box',
      fontSize: '16px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      margin: '0',
    },
    '& > div': {
      fontSize: '14px',
      marginTop: '8px',
      color: '#57729E',
    },
  },
})

export default useStyles
